import script from "./login_phone.vue?vue&type=script&lang=ts&setup=true"
export * from "./login_phone.vue?vue&type=script&lang=ts&setup=true"

import "./login_phone.vue?vue&type=style&index=0&id=04fb8ce8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04fb8ce8"]])

export default __exports__